import React, {useEffect, useState} from "react";
import PageNameV2 from "components/v2/common/PageNameV2";
import PageTitleV2 from "components/v2/common/PageTitleV2";
import ShopSelectBoxV2 from "components/v2/common/ShopSelectBoxV2";
import {getParameter} from "utils/CommonUtils";
import {deliTypeFormat} from "utils/formatUtils";
import {subNavEvent} from "static/js/service/commonService";
import "assets/css/statistics.css";
import chartArrow from "assets/images/chartArrow.svg";
import {createYearList} from "utils/orderUtils";
import {Link} from "react-router-dom";
import { useGetYearlyStatisticsApi} from "hooks/StatisticsHook";
import MonthMultiAxisLineChart from "components/statistics/MonthMultiAxisLineChart";

export default function StatisticsV2() {
  const [shopId, setShopId] = useState();
  const [yearDataList, setYearDataList] = useState([]);
  const getYear = Number(getParameter("year")) || new Date().getFullYear();
  const defaultYear = 2024;
  const deliType = Number(getParameter("deliType")) || 0;
  const yearList = createYearList(new Date().getFullYear(), defaultYear);

  const data = {
    shopId: shopId,
    year: getYear,
  }

  if (deliType !== 0) {
    data.deliveryType = deliType;
  }

  useGetYearlyStatisticsApi({setYearDataList}, data);

  const changeYear = (value) => {
    const yearSelectText = document.querySelector(".yearSelectText");
    yearSelectText.setAttribute("data-id", value);
    yearSelectText.innerText = value;
  };
  const changeDeliType = (id, name) => {
    const yearSelectText = document.querySelector(".deliTypeSelectText");
    yearSelectText.setAttribute("data-id", id);
    yearSelectText.innerText = name;
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      const select = document.querySelectorAll(".selectEvent");
      select.forEach((element) => {
        element.classList.remove("active");
      });

      if (e.target.classList.contains("selectText")) {
        const dataHref = e.target.getAttribute("data-href");
        const selectBox = document.getElementById(`${dataHref}`);
        selectBox.classList.add("active");
      }
    };

    document.addEventListener("click", handleClickOutside);
    subNavEvent("calculateNav", "calculate3");
  }, []);

  const createUrlLink = (id, year, type) => {
    return `/v2/statistics?shopId=${id}&year=${year}&deliType=${type}`;
  }

  const searchEvnet = () => {
    const getShopId = document.querySelector("#shopSelectText").getAttribute("data-id");
    const getYear = document.querySelector("#yearSelectText").getAttribute("data-id");
    const getDeliType = document.querySelector("#deliTypeSelectText").getAttribute("data-id");
    window.location.href = createUrlLink(getShopId, getYear, getDeliType);
  };

  const btnEvent = (year) => {
    const currentYear = new Date().getFullYear();

    // year가 현재 연도 이하이고 defaultYear 이상인 경우에만 실행
    if (year <= currentYear && year >= defaultYear) {
      window.location.href = createUrlLink(shopId, year, deliType);
    }
  };

  return (
    <>
      <main id="statistics" className="mainV2">
        <div className="container">
          <section className="containerInner">
            <PageNameV2 title1='정산 관리' title2='통계' />
            <div className="pageTitle mb-10 d-flex a-center j-between">
              <PageTitleV2 title="통계" countText="" count="" unit="" />
            </div>

            <article className="searchBox d-flex a-end j-left bg-white pt-15 pr-15 pb-10 pl-15 mb-30">
              <div>
                <p className="fw-7 mb-5">상호명</p>
                <div id="shopSelectBox">
                  <ShopSelectBoxV2 url="/v2/statistics" setShopId={setShopId} />
                </div>
              </div>
              <div className="ml-15">
                <p className="fw-7 mb-5">날짜</p>
                <div className='selectBox'>
                  <div id="yearSelect" className='select selectEvent width160'>
                    <div id="yearSelectText" className='yearSelectText selectText' data-id={getYear} data-href="yearSelect">
                      {getYear}
                    </div>
                    <ul className='year selectOptionList'>
                      {yearList.map((value) => {
                        return (
                          <li className='selectoption' key={value} onClick={() => changeYear(value)}>{value}</li>
                        );
                      })}
                    </ul>
                  </div>
                </div>
              </div>
              <div className="ml-15">
                <p className="fw-7 mb-5">주문유형</p>
                <div className='selectBox'>
                  <div id="deliTypeSelect" className='select selectEvent width160'>
                    <div id="deliTypeSelectText" className='deliTypeSelectText selectText' data-id={deliType} data-href="deliTypeSelect">
                      {deliTypeFormat(deliType)}
                    </div>
                    <ul className='deliType selectOptionList'>
                      <li className="selectoption" onClick={() => changeDeliType(0, "전체")}>전체</li>
                      <li className="selectoption" onClick={() => changeDeliType(1, "배달")}>배달</li>
                      <li className="selectoption" onClick={() => changeDeliType(2, "방문포장")}>방문포장</li>
                    </ul>
                  </div>
                </div>
              </div>
              <button className="searchBtn bg-blue fc-white fw-7 ml-15" onClick={() => searchEvnet()}>조회</button>
            </article>

            <article className="tapBtnBox mb-10 bg-white">
              <Link to="/v2/statistics" className="d-inline ta-center bg-blue fc-white fw-7">월별 매출</Link>
              <Link to="/v2/statistics/month" className="d-inline ta-center">일별&시간대별 매출</Link>
            </article>

            <article className="lineChartBox bg-white">
              <div className="d-flex a-center j-between mb-15">
                <div className="width180"></div>
                <div className="btnBox d-flex a-center j-center">
                  <button className="prev" onClick={() => btnEvent(getYear - 1)}>
                    <img src={chartArrow} alt="이전" />
                  </button>
                  <p className="fs-24 fw-7 ml-25 mr-25">{getYear}</p>
                  <button className="next" onClick={() => btnEvent(getYear + 1)}>
                    <img src={chartArrow} alt="다음"/>
                  </button>
                </div>
                <div className="width180 axis d-flex a-center j-right">
                  <span className="green"></span>
                  <p className="fs-14 ml-5">총 매출액</p>
                  <span className="blue ml-20"></span>
                  <p className="fs-14 ml-5">총 주문건수</p>
                </div>
              </div>
              <div className="chartBox">
                <MonthMultiAxisLineChart list={yearDataList} />
              </div>
            </article>
          </section>
        </div>
      </main>
    </>
  )
}